var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'nav-open': _vm.$store.state.sidebar.showSidebar },attrs:{"id":"app"}},[_c('router-view'),_c('the-special-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }